export const environment = {
    production: true,
    api: {
        root: 'https://idep-backoffice-prod.azurewebsites.net'
    }
};